import DashboardFinance from '../organisms/DashboardFinance';
import { WithErrorBoundary } from '@bloomays-lib/ui.shared';
import Box from '@mui/material/Box';
import { PageHeader } from '../molecules/PageHeader';

const Finance = () => {
  return (
    <Box
      sx={{
        margin: 'auto',
        width: '90%',
      }}
    >
      <PageHeader id="financeTitle" title="Les finances de Bloomays" />
      <DashboardFinance />
    </Box>
  );
};

export default WithErrorBoundary(Finance);
